import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { connect, useSelector, useDispatch } from "react-redux";
import { getFormValues, isPristine } from "redux-form";
import { getNativeTemplate } from "../../firebase";
import { Grid, Header } from "semantic-ui-react";
import { fetchBanner } from "../../actions";
import StageBanner from "./banner.js";
import BannerForm from "./form.js";
import Info from "./info.js";
import { DuplicateButton, EditButton, CancelButton } from "../utils/buttons";
import BannerPresets from "./presets.js";

const Stage = ({ bannerForm, location, id, template, retailer, pristine }) => {
  const params = useParams();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.user);
  const banner = useSelector((state) => state.banner);
  const [inEdit, setInEdit] = useState();
  const [bannerData, setBannerData] = useState({});
  const [formOrInfo, setFormOrInfo] = useState(<Info />);
  const [selectors, setSelectors] = useState();

  useEffect(() => {
    const path = location.pathname.split("/");
    const status = path[4] ? true : false;
    setInEdit(status);
  }, [location.pathname]);

  useEffect(() => {
    const data = bannerForm || banner;
    setBannerData(data);
    return () => {
      setBannerData({});
    };
  }, [banner, bannerForm]);

  //useEffect(() => {
  //  console.log("templates", template);
  //}, [template]);

  useEffect(() => {
    const templateName = banner.bannerType || template.name;
    getNativeTemplate(retailer, templateName).then((data) => {
      setSelectors(data.selectors);
    });
  }, [retailer, template, banner]);

  useEffect(() => {
    if (template && !bannerData.bannerType)
      dispatch(fetchBanner(BannerPresets));
  }, [bannerData.bannerType, template, dispatch]);

  useEffect(() => {
    if ((user && params["*"] === "edit") || (user && params["template"])) {
      setFormOrInfo(<BannerForm retailer={retailer} template={template} />);
    } else {
      setFormOrInfo(<Info />);
    }
  }, [params, user, retailer, template]);

  return (
    <>
      <div className="brand-template">
        <Grid padded>
          <Grid.Row className="bm-title-row">
            <Grid.Column computer={10} tablet={8} mobile={16}>
              <Header as="h3" content={bannerData.bannerTitle} />
            </Grid.Column>
            {user && (
              <Grid.Column computer={6} tablet={8} mobile={16}>
                {bannerData.key && !inEdit && (
                  <DuplicateButton
                    data={bannerData}
                    location={location}
                    inUse={bannerData.currentUser}
                    size="mini"
                  />
                )}
                {!inEdit && (
                  <EditButton
                    id={id}
                    inUse={bannerData.currentUser}
                    size="mini"
                  />
                )}
                <CancelButton
                  id={id}
                  location={location}
                  retailer={retailer}
                  pristine={pristine}
                  size="mini"
                />
              </Grid.Column>
            )}
          </Grid.Row>
        </Grid>
        <StageBanner banner={bannerData} selectors={selectors} />
      </div>
      {formOrInfo}
    </>
  );
};

export default connect((state) => ({
  bannerForm: getFormValues("bannerForm")(state),
  pristine: isPristine("bannerForm")(state),
}))(Stage);
